<template>
  <div>
    <el-form :model="formData"  label-width="90px">
        <el-form-item label="产品:" required>
            <ListCheck v-model="formData.appId" @change="handleAppChange" :list="appList">
                <template #default="{ row }">
                    <p>{{row.app_name}}</p>
                    <p>({{row.app_id}})</p>
                    <span>创意组：{{totalNum[row.package_name] || 0}}</span>
                    <i v-show="showTipIcon[row.package_name]" title="素材存在必填项，请检查" class="el-icon-question tip-icon"/>
                </template>
            </ListCheck>
        </el-form-item>
        <el-form-item label="广告组:" required>
            <ListCheck v-model="formData.groupId" :list="groupList">
                <template #default="{ row }">
                    <p >ID：{{row.group_id}}({{totalNum[row.key] || 0}})</p>
                    <span class="text-tip">({{row.group_name}})</span>
                    <i v-show="showTipIcon[row.key]" title="素材存在必填项，请检查" class="el-icon-question tip-icon"/>
                </template>
            </ListCheck>
        </el-form-item>
        <el-form-item label="展现形式:" required>
            <ListCheck v-model="formData.displayId" :list="displayList">
                <template #default="{ row }">
                    {{row.displayKey}}
                    <p>{{row.display_type_text}}({{totalNum[row.key] || 0}})</p>
                    <i v-show="showTipIcon[row.key]" title="素材存在必填项，请检查" class="el-icon-question tip-icon"/>
                </template>
            </ListCheck>
        </el-form-item>
        <el-form-item label="创意规格:" required>
            <ListCheck v-model="formData.normId" :list="normList">
                <template #default="{ row }">
                    {{row.normKey}}
                    <p>{{row.norm_model_text}}({{totalNum[row.key] || 0}})</p>
                    <i v-show="showTipIcon[row.key]" title="素材存在必填项，请检查" class="el-icon-question tip-icon"/>
                </template>
            </ListCheck>
        </el-form-item>
    </el-form>
  </div>
</template>

<script>
import ListCheck from './listCheck.vue'
import {  cloneDeep } from 'lodash'
export default {
    name: 'FormBox',
    components: {
        ListCheck,
    },
    props: [ 'appList', 'advGroup', 'selectData' ],
    data() {
        return {
            formData: {
                appId: '',
                groupId: '',
                displayId: '',
                normId: ''
            },
            initKeyData: {}
        }
    },
    computed: {
        totalNum() {
            let initData = cloneDeep(this.selectData);
            initData = this.appList.reduce((pre, item)=> {
                const appId = item.package_name;
                const constData = this.initKeyData[appId] || {};

                const itemData = Object.keys(initData)
                .reduce((pre, key)=> {
                    if (!constData[key]) {
                        return pre
                    }
                    const config = constData[key].filter(v=>v.material_is_null === '0');
                    if (!config) {
                        return pre
                    };
                    const list = initData[key].filter(v=> {
                        return config.every(item=>{
                            const explicit_name = item.explicit_name;
                            return !!v[explicit_name]
                        })
                    });
                    pre[key] = list;
                    return pre;
                }, {});
                return {
                    ...pre,
                    ...itemData
                }
            }, { })

           return this.getTotalNum(initData)
        },
        groupList() {
            const { appId } = this.formData;
            // const totalNum = this.totalNum
            if (!appId) {
                return []
            };
            const advGroup = cloneDeep(this.advGroup);
            return this.setDataKey(advGroup, appId)
        },
        displayList() {
            const groupId = this.formData.groupId;
            if (!groupId) {
                return []
            };
            const advGroup = this.groupList
            const item = advGroup.find(v=> v.group_id === groupId);
            return (item?.display_list || []).map(v=> {
                return {
                    ...v,
                    value: v.display_type
                }
            })
        },
        normList() {
            const displayId = this.formData.displayId;
            if (!displayId) {
                return []
            }
            const item = this.displayList.find(v=> v.display_type === displayId);
            return (item?.norm_list || []).map(v=> {
                return {
                    ...v,
                    value: `${ v.norm_model }_${v.norm_id}`
                }
            })
        },
        initId() {
            const groupId = this.advGroup[0]?.value
            const displayId = this.displayList[0]?.value
            const normId = this.normList[0]?.value
            return {
                groupId,
                displayId,
                normId
            }
        },
        initTotalNum() {
            const initTotalNum = this.getTotalNum(cloneDeep(this.selectData));
            return initTotalNum
        },
        showTipIcon() {
            const totalNum = this.totalNum;
            const initTotalNum = this.initTotalNum;
            return Object.keys(initTotalNum).reduce((pre, key)=> {
                if (initTotalNum[key]) {
                    if (initTotalNum[key] !== totalNum[key]) {
                        pre[key] = true
                    }else {
                        pre[key] = false
                    }
                }else {
                    pre[key] = false
                }
                return pre;
            }, {})
        }
    },
    mounted() {
        const fn = (cb)=>{
            console.log(this.selectData,'selectData');
            const initTotalNum = this.getTotalNum(cloneDeep(this.selectData))
            cb(this.totalNum, initTotalNum , this.appList)
        }
        this.$bus.$on('getTotalNum',fn);
        this.$once('hook:beforeDestroy', () => {
            this.$bus.$off('getTotalNum', fn)
        });
    },
    watch: {
        appList: {
            handler(n) {
                if (n.length > 0) {
                    this.formData.appId = n[0].value
                }
            },
            immediate: true
        },
        advGroup(n) {
            if (n.length) {
                this.formData.groupId = n[0].value
            }
        },
        'groupList'(n) {
            const id = this.displayList[0]?.value || ''
            this.formData.displayId = id
        },
        'displayList'(n) {
            const id = this.normList[0]?.value || ''    //单切广告组有问题
            this.formData.normId = id
        },
        'formData.displayId'(name) {
           const id = this.normList[0]?.value || ''    //单切广告组有问题
            this.formData.normId = id
        },
        'formData.groupId'(name) {
          const id = this.displayList[0]?.value || ''
          this.formData.displayId = id
        },
        'formData.appId'(name) {
            const data = this.appList.find(v=>v.package_name ===name);
            let app_name = (data?.app_name || '').split('-')
            this.$emit('update:appName', app_name[0])
            this.$bus.$emit('updateAppData', data.app_name)
        },
        'formData.normId'(n) {
           const data = this.normList.find(v=> v.value === n)
           this.$emit('update:config', data?.config || [])
        },
        formData: {
            handler(n) {
                this.$emit('form-change', n)
            },
            deep: true
        }
    },
    methods: {
        handleAppChange(name) {
            Object.assign(
                this.formData,
                this.initId
            );
        },
        setDataKey(advGroup, appId) {
            const keyObj = {};
             (function getNum (list = advGroup, keys=appId){
                list.forEach(v=> {
                    const key = `${keys}-${v.group_id || v.display_type || `${ v.norm_model }_${v.norm_id}`}`;
                    v.key = key;
                    if (v.norm_id) {
                        keyObj[key] = v.config
                    }
                    const list = v.display_list || v.norm_list || []
                    if (list.length) {
                        getNum(list, key)
                    }
                })
            })();
            this.initKeyData[appId] = keyObj;
            return advGroup
        },
        getTotalNum(initData) {
            const count = {};
            Object.keys(initData).forEach(key=> {
                const [ appId, groupId, displayId, normId ] = key.split('-');
                const num = initData[key].length;
                if (!count[appId]) {
                    count[appId] = 0
                }
                // 产品数量
                count[appId] +=  num

                const groupNum = `${appId}-${groupId}`;
                if (!count[groupNum]) {
                    count[groupNum] = 0
                }
                // 广告组数量
                count[groupNum] +=  num

                const displayNum = `${appId}-${groupId}-${displayId}`;
                if (!count[displayNum]) {
                    count[displayNum] = 0
                }
                // 展现形式数量
                count[displayNum] +=  num;


                const normNum = `${appId}-${groupId}-${displayId}-${normId}`;
                if (!count[normNum]) {
                    count[normNum] = 0
                }
                // 创意规格数量
                count[normNum] +=  num
            });
            console.log(count);
            return count;
        }
    }
}
</script>

<style lang="scss" scoped>

.text-tip {
    display: inline-block;
    max-width: 250px;
    text-wrap: wrap;
    line-height: 18px;
}
.tip-icon {
    font-size: 12px;
    position: absolute;
    top: 6px;
    right: 6px;
    color: rgba(255, 0, 0, 0.6);
}
</style>
